module.exports = __webpack_public_path__ + "static/img/comme_chez_maman.94c7241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/comme_chez_maman.png
// module id = Qpk/
// module chunks = 1